(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationSaveInsuranceQuotes',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var label_name = 'reservationsaveinsurancequotes';

		// clicking the purchase now button
		$('.purchase-quote').on('click', function onPurchaseQuoteClick(event)
		{
			var button   = $(event.target);
			var checkbox = null;

			// uncheck everything first
			$('.reservation-box input[type="checkbox"]').each(function onEachCheckbox(index, elem) {
				if ($(elem).is(':checked')) {
					$(elem).prop('checked', false);
				}
			});

			checkbox = button.parent().parent()
							 .find('input[type="checkbox"]').first();

			// check it's corresponding checkbox
			// and set the hidden input value
			if (!checkbox.is(':checked')) {
				checkbox.prop('checked', true);
				$('#' + label_name + '-purchase_quote').val(1);
			}
		});

		// TODO fix the submission spinners

		$(".email-quote").on('click', function mirrorEmailQuoteCheckbox() {
			$('.email-quote').prop('checked', $(this).prop('checked'));
		});
	};

}(jQuery, window.Adzuki || {}));
